import styled from 'styled-components';
import { largeLayout } from '@styles/layout';

const Explain = styled.div`
  width: ${largeLayout.getSize(4)}px;
`;

export const ExplainLeft = Explain.extend`
  text-align: right;
`;

export const ExplainRight = Explain.extend`
  text-align: left;
  margin-left: ${largeLayout.getPosition(8)}px
`;

type VerticalSpaceProps = { size: number; };
export const VerticalSpace = styled.div`
  height: ${(props: VerticalSpaceProps) => props.size}px;
`;


// WEBPACK FOOTER //
// src/app/src/components/SectionPhone/SectionPhone.s.ts